import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventListWidgetComponent } from './components/event-list-widget/event-list-widget.component';

const routes: Routes = [
  { path: '', component: EventListWidgetComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventsRouterResultsModule { }
